<template>
  <div class="polls">
    <poll-form v-if="activePoll" @submitAnswer="submitted"></poll-form>

    <poll-results v-else-if="sharedPollResults"></poll-results>
  </div>
</template>

<script>
import PollForm from './poll-form';
import PollResults from './poll-results';

const Polls = {
  name: 'Polls',

  components: {
    PollForm,
    PollResults
  },

  data() {
    return {
      pollStartTime: 0,
      answeredElapsedSecs: 0,
      pollResultsStartTime: 0
    };
  },


  computed: {
    activePoll() {
      return this.$store.state.g2wSession.polls.active;
    },

    sharedPollResults() {
      return this.$store.state.g2wSession.polls.sharedResults;
    }
  },

  watch: {
    activePoll: {
      immediate: true,
      handler(poll) {
        if (poll) {
          this.$telemetryTrack('poll open', {isMultipleChoice: poll.isMultipleChoice});
          this.pollStartTime = Date.now();
        } else if (this.pollStartTime) {
          const elapsedSecs = Math.round((Date.now() - this.pollStartTime) / 1000);
          this.$telemetryTrack('poll close', {
            elapsedSecs,
            answered: !!this.answeredElapsedSecs,
            answerElapsedSecs: this.answeredElapsedSecs
          });
          this.pollStartTime = 0;
          this.answeredElapsedSecs = 0;
        }
      }
    },

    sharedPollResults(results) {
      if (results) {
        this.pollResultsStartTime = Date.now();
        this.$telemetryTrack('poll results open');
      } else if (this.pollResultsStartTime) {
        const durationSecs = Math.round((Date.now() - this.pollResultsStartTime) / 1000);
        this.$telemetryTrack('poll results close', {durationSecs});
        this.pollResultsStartTime = 0;
      }
    }
  },

  methods: {
    submitted() {
      this.answeredElapsedSecs = Math.round((Date.now() - this.pollStartTime) / 1000);
      this.$telemetryTrack('poll answered', {elapsed: this.answeredElapsedSecs});
    }
  }
};

export default Polls;
</script>
